module.exports = __webpack_public_path__ + "static/img/szafa_42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_42.jpg
// module id = dBbj
// module chunks = 0